import React from 'react';
import { Anchor } from 'ui/components';

export const AnchorFeature: React.FC<Umbraco.Anchor> = ({ content }) => {
    return <Anchor {...content?.properties} />;
};
